import Button from 'assets/components/button/Button';
import ThemeButtonMenuItem from 'assets/components/button/themes/Theme.Button.MenuItem';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import { getLocales } from 'assets/locales/Locale';
import DropdownButton from 'assets/templates/dropdownButton/DropdownButton';
import ThemeDropdownButtonPopup from 'assets/templates/dropdownButton/themes/Theme.DropdownButton.Popup';
import { useClaimProvider } from '../Claim.Hooks';

export default function ClaimActions() {
  const { lang } = getLocales();
  const { selectedClaims, bulkChangeClaimOwner, bulkOwnerUserListApi } = useClaimProvider();

  return (
    <DropdownButton
      title={lang.transferOwnershipTo}
      buttonBody={lang.changeOwner}
      buttonMedia={<Icon class="fas-user" />}
      horizontalPosition="auto_fixed"
      verticalPosition="auto_fixed"
      constrainment="constrained"
      tabIndex={null}
      disabled={!selectedClaims?.length}
      htmlElementProps={{
        title: !selectedClaims?.length ? lang.selectAtLeastOneContract : lang.changeOwner,
      }}
      subcomponents={ThemeDropdownButtonPopup}
      dropdownOptions={
        <DataMap
          data={bulkOwnerUserListApi?.payload?.data}
          render={({ data: user }) => (
            <Button
              key={user?.id}
              class={ThemeButtonMenuItem}
              render={user?.displayInfo?.title}
              onClick={() => bulkChangeClaimOwner(user.id)}
              data={user}
            />
          )}
        />
      }
    />
  );
}
